import { useCallback, useState, useRef } from 'react'

export const useDescriptionSearch = (
  onDescriptionChange: (value: string | undefined) => void,
): {
  description: string
  handleDescriptionChange: (value: string) => void
  handleDescriptionClear: () => void
  initializeDescription: (value: string) => void
} => {
  const [description, setDescription] = useState('')
  const timer = useRef<number>()

  const handleDescriptionChange = useCallback(
    (value: string) => {
      setDescription(value)

      // Clear existing timer
      if (timer.current) {
        clearTimeout(timer.current)
      }

      // If value is empty, clear immediately
      if (value.trim() === '') {
        onDescriptionChange(undefined)
        return
      }

      // Set new timer for debounced search
      timer.current = window.setTimeout(() => {
        onDescriptionChange(value.trim() || undefined)
      }, 1000)
    },
    [onDescriptionChange],
  )

  const handleDescriptionClear = useCallback(() => {
    setDescription('')
    onDescriptionChange(undefined)
    if (timer.current) {
      clearTimeout(timer.current)
    }
  }, [onDescriptionChange])

  const initializeDescription = useCallback((value: string) => {
    setDescription(value)
  }, [])

  return {
    description,
    handleDescriptionChange,
    handleDescriptionClear,
    initializeDescription,
  }
}
